/**
 * Prix de départ d'un lieu : SAISI HT, AFFICHÉ TTC.
 *
 * Les lieux annoncent toujours leurs tarifs hors taxes : `lieux.tarif_minimum` est donc un
 * montant HT, dans l'admin comme dans le formulaire « Proposer votre lieu ». Jusqu'au
 * 23/10/2026, le site le lisait comme TTC : Archives (1 000 € HT) s'affichait « 1 000 € TTC,
 * soit ~833 € HT », 200 € sous son vrai prix.
 *
 * Taux : celui de la catégorie « lieux » (utils/vatCalculations), appliqué à tous les lieux
 * — décision du 23/10/2026, y compris ceux qui ne facturent pas de TVA.
 */
import { calculateTTCForService, formatVATRate } from './vatCalculations';

/**
 * Arrondi à l'euro SUPÉRIEUR : un « à partir de » ne promet jamais moins que le prix réel.
 * `tarif_minimum` est un entier en base : aucun montant de 1 à 100 000 € HT n'est faussé
 * par l'arrondi flottant (vérifié le 23/10/2026).
 */
export const prixLieuTTC = (ht: number): number => Math.ceil(calculateTTCForService(ht, 'lieux'));

export const TAUX_TVA_LIEUX = formatVATRate('lieux');

export const euros = (montant: number) => `${montant.toLocaleString('fr-FR')} €`;
